// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".care .divider{display:none}.care .title{margin-bottom:8px}.care .care-list{list-style-type:disc;margin-left:20px}.care .care-list .care-list-item{display:list-item}@media (max-width: 969px){.care{margin-top:24px}.care .divider{display:block;margin-top:10px;margin-bottom:24px}}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
